import { z } from 'zod'

export const FormOptions = z.union([z.array(z.string()).readonly(), z.string()])

const BaseFieldRegistryEntry = z.object({
  description: z.string(),
  fieldType: z.string(),
  placeholder: z.string().optional(),
  required: z.boolean().default(true).optional(),
  label: z.string(),
  tooltip: z.string().optional(),
  maxPhotos: z.number().optional(),
})

const TextFieldRegistryEntry = BaseFieldRegistryEntry.extend({
  fieldType: z.literal('text'),
})

const NumberFieldRegistryEntry = BaseFieldRegistryEntry.extend({
  fieldType: z.literal('number'),
})

const SelectFieldRegistryEntry = BaseFieldRegistryEntry.extend({
  fieldType: z.union([
    z.literal('radio'),
    z.literal('select'),
    z.literal('searchable-select'),
    z.literal('typeahead'),
  ]),
  options: FormOptions,
})

const MonthFieldRegistryEntry = BaseFieldRegistryEntry.extend({
  fieldType: z.literal('date'),
})

const TextAreaFieldRegistryEntry = BaseFieldRegistryEntry.extend({
  fieldType: z.literal('textarea'),
})

const HiddenFieldRegistryEntry = BaseFieldRegistryEntry.extend({
  fieldType: z.literal('hidden'),
})

const PhotosFieldRegistryEntry = BaseFieldRegistryEntry.extend({
  fieldType: z.literal('photos'),
})

export const FieldRegistryEntry = z.union([
  TextFieldRegistryEntry,
  NumberFieldRegistryEntry,
  SelectFieldRegistryEntry,
  MonthFieldRegistryEntry,
  TextAreaFieldRegistryEntry,
  PhotosFieldRegistryEntry,
  HiddenFieldRegistryEntry,
])
type FieldRegistryEntry = z.infer<typeof FieldRegistryEntry>

export const fieldRegistry = z.registry<FieldRegistryEntry>()
